import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { apiGetProcess } from "../../../api/ApiProcess";
import { selectReduxInstance } from "../../../redux/ReduxInstance";

const ModalOrgunitsList = (props) => {
  const { t } = useTranslation();
  const { processId, show, handleClose } = props;
  const ReduxInstance = useSelector(selectReduxInstance);
  const [process, setProcess] = useState("");

  useEffect(() => {
    if (processId) {
      recupProcess();
    }
  }, [processId]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupProcess = async () => {
    const res = await apiGetProcess(ReduxInstance._id, processId, "include=orgunits");
    if (res) {
      setProcess(res.data);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("public.componentProcess.modalResponsables")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginTop: 5 }}>
          <div>
            <strong>{process.nom}</strong> :
          </div>
          <div style={{ paddingTop: 5 }}>
            {process &&
              process.orgunits.map((orgunit, key) => {
                return (
                  <Link to={"/orgunits/" + orgunit._id} key={orgunit._id}>
                    - {orgunit.nom}
                    <br />
                  </Link>
                );
              })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>{t("public.componentProcess.modalFermer")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalOrgunitsList;
